import React from 'react';
import { Aircraft } from '../../types/aircraft';
import { Plane } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useCurrency } from '../../hooks/useCurrency';

interface AircraftPreviewCardProps {
  aircraft: Aircraft;
}

export const AircraftPreviewCard: React.FC<AircraftPreviewCardProps> = ({ aircraft }) => {
  const { t } = useLanguage();
  const { format } = useCurrency();
  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-3 flex-1 min-w-0">
          <div className="p-2 bg-blue-50 rounded-lg flex-shrink-0">
            <Plane className="w-5 h-5 text-blue-600" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold text-gray-900 truncate">{aircraft.registration}</h3>
            <p className="text-sm text-gray-600 truncate">
              {aircraft.manufacturer} {aircraft.model}
            </p>
            <div className="flex items-center space-x-2 mt-1">
              {aircraft.year && (
                <span className="text-xs text-gray-500">{aircraft.year}</span>
              )}
              {aircraft.baseAirportICAO && (
                <>
                  {aircraft.year && <span className="text-xs text-gray-400">•</span>}
                  <span className="text-xs text-gray-500">{aircraft.baseAirportICAO}</span>
                </>
              )}
            </div>
          </div>
        </div>
        {aircraft.hourlyRate && (
          <div className="text-right flex-shrink-0 ml-2">
            <p className="text-sm font-medium text-gray-900">
              {format(aircraft.hourlyRate, { maximumFractionDigits: 0 })}<span className="text-xs text-gray-500">{t('common.perHour')}</span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

